/**
 * =========================================================
 * Footer — Fundri global i aplikacionit
 * =========================================================
 * Çfarë bën: Tregon linkun e privatësisë, versionin dhe
 *            kontaktin e mbështetjes. Shfaqet brenda <main>
 *            pas çdo faqeje të aplikacionit të autentikuar.
 * Dizajn: border-t, tekst neutral, stil minimal premium.
 * =========================================================
 */

import { Link } from "react-router-dom";

const YEAR = new Date().getFullYear();

export const Footer = (): JSX.Element => (
  <footer className="mt-10 border-t border-slate-200/60 bg-transparent">
    <div className="mx-auto px-2 py-5">
      <div className="flex flex-wrap items-center justify-between gap-3 text-xs text-slate-400">
        {/* Të drejtat e autorit */}
        <p className="shrink-0">
          © {YEAR}{" "}
          <span className="font-semibold text-primary">e-Shëndetësia</span>
          {" · "}Platforma dixhitale e shëndetit · Kosovë
        </p>

        {/* Lidhjet kryesore */}
        <nav aria-label="Footer navigation" className="flex flex-wrap gap-x-4 gap-y-1">
          <Link to="/about"       className="transition-colors hover:text-primary focus-visible:underline">Rreth nesh</Link>
          <Link to="/privacy" className="transition-colors hover:text-primary focus-visible:underline">Privatësia</Link>
          <a href="mailto:support@eshendetesia.al" className="transition-colors hover:text-primary focus-visible:underline">Mbështetja</a>
          <span className="text-slate-300">v1.0.2</span>
        </nav>
      </div>
    </div>
  </footer>
);

/**
 * =========================================================
 * Fund i Footer
 * =========================================================
 */
